<div class="_merge-clients-desktop-page">

	<page-header-component title="{{'MERGE_CLIENTS.TITLE' | translate}}"></page-header-component>

    <div class="_explanation-container">
        <p>{{'MERGE_CLIENTS.SUBTITLE' | translate}}</p>
    </div>

    <div class="_clients-container">

        <div class="_origin-client _client-container">
            <search-client (selected)="onClientSelect($event, 'origin')"></search-client>

            <ng-container *ngIf="originClient">
                <div class="_client-details-container">
                    <div class="_details-entries-container _client-details-container">
                        <client-details-component [client]="originClient" [clientNavigationEnabled]="false"></client-details-component>
                    </div>
                </div>

                <ng-container [ngTemplateOutlet]="reservations" [ngTemplateOutletContext]="{client: originClient}"></ng-container>
                <ng-container [ngTemplateOutlet]="beegoAppointments" [ngTemplateOutletContext]="{client: originClient}"></ng-container>
                <ng-container [ngTemplateOutlet]="waitList" [ngTemplateOutletContext]="{client: originClient}"></ng-container>
                <ng-container [ngTemplateOutlet]="loans" [ngTemplateOutletContext]="{client: originClient}"></ng-container>

            </ng-container>

        </div>

        <div class="_arrow">
            <ion-icon src="./assets/icons/arrow-right-outline.svg"></ion-icon>
            <ng-container *ifUserHasPermissions="[UserPermissions.MergeClients]">
                <button (click)="mergeClients()" class="_button _merge-button" *ngIf="originClient && targetClient">
                    <span [translate]="'MERGE_CLIENTS.TITLE'"></span>
                </button>
            </ng-container>
        </div>

        <div class="_target-client _client-container">
            <search-client (selected)="onClientSelect($event, 'target')"></search-client>


            <ng-container *ngIf="targetClient">
                <div class="_client-details-container">
                    <div class="_details-entries-container _client-details-container">
                        <client-details-component [client]="targetClient" [clientNavigationEnabled]="false"></client-details-component>
                    </div>
                </div>

                <ng-container [ngTemplateOutlet]="reservations" [ngTemplateOutletContext]="{client: targetClient}"></ng-container>
                <ng-container [ngTemplateOutlet]="beegoAppointments" [ngTemplateOutletContext]="{client: targetClient}"></ng-container>
                <ng-container [ngTemplateOutlet]="waitList" [ngTemplateOutletContext]="{client: targetClient}"></ng-container>
                <ng-container [ngTemplateOutlet]="loans" [ngTemplateOutletContext]="{client: targetClient}"></ng-container>

            </ng-container>
            
        </div>

    </div>
	
</div>

<ng-template #reservations let-client="client">
    <div class="_client-details-container">
        <p class="_title" [translate]="'MERGE_CLIENTS.RESERVATIONS'"></p>
        <div class="_details-entries-container">
            <ng-container *ngIf="(client.Reservations ?? []).length > 0">
                <div class="_details-entry-container" *ngFor="let reservation of (client.Reservations ?? []); let i = index" [ngClass]="{'_offset': i % 2 !== 0}">
                    <div>
                        <p>{{reservation.Event.name}}</p>
                        <p class="_details">
                            {{(reservation.startsAt ?? reservation.CalendarEvent.startsAt) | date:"dd/MM/yy"}} 
                            {{(reservation.startsAt ?? reservation.CalendarEvent.startsAt) | date:"HH:mm"}} - 
                            {{(reservation.endsAt ?? reservation.CalendarEvent.endsAt) | date:"HH:mm"}}
                        </p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="(client.Reservations ?? []).length === 0">
                <div class="_details-entry-container">
                    <p class="_no-entries" [translate]="'MERGE_CLIENTS.NO_RESERVATIONS'"></p>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #beegoAppointments let-client="client">
    <div class="_client-details-container">
        <p class="_title" [translate]="'MERGE_CLIENTS.BEEGO_APPOINTMENTS'"></p>
        <div class="_details-entries-container">
            <ng-container *ngIf="(client.BeegoAppointments ?? []).length > 0">
                <div class="_details-entry-container" *ngFor="let beegoAppointment of (client.BeegoAppointments ?? []); let i = index" [ngClass]="{'_offset': i % 2 !== 0}">
                    <div>
                        <p>
                            {{beegoAppointment.CalendarEvent.startsAt | date:"dd/MM/yy"}} 
                            {{beegoAppointment.CalendarEvent.startsAt | date:"HH:mm"}} - 
                            {{beegoAppointment.CalendarEvent.endsAt | date:"HH:mm"}}
                        </p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="(client.BeegoAppointments ?? []).length === 0">
                <div class="_details-entry-container">
                    <p class="_no-entries" [translate]="'MERGE_CLIENTS.NO_BEEGO_APPOINTMENTS'"></p>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #waitList let-client="client">
    <div class="_client-details-container">
        <p class="_title" [translate]="'MERGE_CLIENTS.WAIT_LIST'"></p>
        <div class="_details-entries-container">
            <ng-container *ngIf="(client.WaitList ?? []).length > 0">
                <div class="_details-entry-container" *ngFor="let waitListItem of (client.WaitList ?? []); let i = index" [ngClass]="{'_offset': i % 2 !== 0}">
                    <div>
                        <p>{{waitListItem.type}}</p>
                        <p class="_details">
                            {{waitListItem.createdAt | date:"dd/MM/yy HH:mm"}} - {{waitListItem.description}}
                        </p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="(client.WaitList ?? []).length === 0">
                <div class="_details-entry-container">
                    <p class="_no-entries" [translate]="'MERGE_CLIENTS.NO_WAIT_LIST_ITEMS'"></p>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #loans let-client="client">
    <div class="_client-details-container">
        <p class="_title" [translate]="'MERGE_CLIENTS.LOANS'"></p>
        <div class="_details-entries-container">
            <ng-container *ngIf="(client.Loans ?? []).length > 0">
                <div class="_details-entry-container" *ngFor="let loan of (client.Loans ?? []); let i = index" [ngClass]="{'_offset': i % 2 !== 0}">
                    <div>
                        <p>{{loan.Devices[0].DeviceType.name}}</p>
                        <p class="_details">
                            {{(loan.startsAt) | date:"dd/MM/yy"}}  - {{(loan.endsAt) | date:"dd/MM/yy"}} 
                        </p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="(client.Loans ?? []).length === 0">
                <div class="_details-entry-container">
                    <p class="_no-entries" [translate]="'MERGE_CLIENTS.NO_LOANS'"></p>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>



